import { createNewProject } from '.'
import { Navigate } from 'react-router-dom'
import { useAsyncError } from '../errorBoundary/useAsyncError'

import { useContext } from 'react'
import { AppContext } from '../App'
import { NewProjectIcon } from '../icons/NewProjectIcon'

const NewProjectButton = () => {
  const { state, dispatch } = useContext(AppContext)
  const throwAsyncError = useAsyncError()

  return (
    <>
      {(!state.currentProject.projectId)
        ? (
          <button
            className='btn btn-success mt-10'
            onClick={() => createNewProject(dispatch, throwAsyncError)}
          >
            <NewProjectIcon />
            New project
          </button>
          )
        : (
          <Navigate to={`/project/${state.currentProject.projectId}`} />
          )}
    </>
  )
}

export { NewProjectButton }
